/* ===========================================================================
 * CAN WE ENGRAVE WHAT THEY TYPED? One checker, shared by the whole theme.
 * Lorenzo, 18 October 2026: "can we connect the text field on the product page
 * to validate if we can engrave the characters that are entered?"
 *
 * There are two engraving boxes on this site - one on the product page and one
 * in the cart - and they must not disagree about a character. So the rule lives
 * here, in one file, and both boxes ask it. The cart (assets/sp-cart.js) asks
 * it already; the product page is Lore PC's and calls the same three functions.
 *
 * WHAT IT IS A COPY OF. The order system decides this in the database, with
 * engraving_is_engravable(engraving_normalise(text)). Both functions were read
 * out of the live database on 18 October 2026 with pg_get_functiondef and
 * copied here step for step, after migration 1646 widened the allowed set.
 *
 * ================= IT ASKS THE APP FIRST, AND KEEPS A COPY =================
 * Lorenzo, 18 October 2026: "ERP main is working on adding the approved list to
 * the app. how can we link that to the engraving text field on the website".
 *
 * THE APP'S LIST WINS. The app keeps the list in public.engraving_charset and
 * publishes it into the shop metafield sesto.engraving_allowed;
 * snippets/sp-engrave-list.liquid prints it into the page as JSON and this file
 * reads it. When a good payload is there, its ranges REPLACE the copy below, so
 * the shop follows the app the day the app changes and nobody has to remember
 * this file.
 *
 * THE COPY BELOW IS THE FALLBACK, for a page with no tag - which is every page
 * today, because the metafield has not been written to the store yet. It is
 * still a copy and copies still go stale: if you change the app's list and the
 * metafield is not live yet, GENERATE the copy again from
 * public.engraving_charset rather than editing it by hand, and put the cache
 * row's allowed_md5 into BUILT_IN_ALLOWED_MD5. The page logs when the live list
 * has moved past the copy.
 *
 * It has already moved three times in one day - 1646, then 1650 and 1651, then
 * 1652 - which is the whole argument for the metafield doing this instead.
 *
 * WHY A COPY AT ALL. The shop's pages cannot reach the order system, and the
 * customer needs the answer while they are still typing. The database stays the
 * one that decides: this only saves the customer from finding out later.
 *
 * WHAT IT DOES
 *   SestoEngrave.normalise(text)  - the text as the order system will store it
 *   SestoEngrave.refused(text)    - the characters we cannot engrave, [] if none
 *   SestoEngrave.message(text)    - a sentence to show, '' if there is nothing
 *                                   wrong
 *   SestoEngrave.source()         - which list this page is actually using
 * ======================================================================== */

(function () {
  'use strict';

  /* LOADED TWICE IS NOT AN ERROR. The cart page and the cart drawer both pull
     this file in, and on a page that has both it arrives twice. The first copy
     wins and the second does nothing, so nothing is rebuilt under a box that is
     already using it. */
  if (window.SestoEngrave) { return; }

  /* ------------------------------------------------------------- normalise */

  /* WHAT THE DATABASE DOES TO THE WORDS BEFORE IT JUDGES THEM, in the same
     order. engraving_normalise, read 18 October 2026:

       1. five HTML entities back into their characters;
       2. translate the curly quotes and the long dashes to straight ones;
       3. every run of whitespace down to one plain space;
       4. trim;
       5. empty becomes NULL - here it becomes '', which the rule treats the
          same way, because a text with no characters in it has no character we
          cannot engrave.

     Steps 1 and 2 are a pair of safety nets rather than a convenience: a phone
     keyboard gives the customer a curly apostrophe whether they want one or
     not, and the straight one is what the laser is given. */

  /* THE ENTITIES, INNERMOST FIRST, because the database nests five replace()
     calls and the order is load-bearing: "&amp;quot;" has to become "&quot;"
     and not a quotation mark. */
  var ENTITIES = [
    ['&quot;', '"'],
    ['&amp;', '&'],
    ['&#39;', "'"],
    ['&lt;', '<'],
    ['&gt;', '>']
  ];

  /* The curly quotes and long dashes, and what each becomes. Two lists of the
     SAME LENGTH - the database's own comment warns that an earlier draft had
     seven in and eight out, which slid every space onto a hyphen. */
  var CURLY = '’‘“”–—';
  var STRAIGHT = '\'\'""--';

  /* WHITESPACE, WRITTEN OUT, because JavaScript and Postgres do not agree about
     it. JavaScript's \s counts U+FEFF as whitespace and Postgres does not, so a
     \s here would quietly swallow a character the order system would refuse.
     This class is the set Postgres matched when it was asked, character by
     character, on 18 October 2026 - including U+0085, which is easy to miss. */
  var WS = '\\u0009-\\u000D\\u0020\\u0085\\u00A0\\u1680\\u2000-\\u200A' +
           '\\u2028\\u2029\\u202F\\u205F\\u3000';
  var WS_RUN = new RegExp('[' + WS + ']+', 'g');

  function normalise(text) {
    var s = (text === null || text === undefined) ? '' : String(text);
    var i;

    for (i = 0; i < ENTITIES.length; i++) {
      s = s.split(ENTITIES[i][0]).join(ENTITIES[i][1]);
    }

    var out = '';
    for (i = 0; i < s.length; i++) {
      var at = CURLY.indexOf(s.charAt(i));
      out += (at === -1) ? s.charAt(i) : STRAIGHT.charAt(at);
    }

    /* TRIM TAKES SPACES ONLY, like the database's btrim with no second
       argument. It is enough, because the line above has already turned every
       other kind of whitespace into a plain space. */
    return out.replace(WS_RUN, ' ').replace(/^ +/, '').replace(/ +$/, '');
  }

  /* --------------------------------------------------- what we can engrave */

  /* ==================== THE FALLBACK COPY OF THE LIST ====================
     GENERATED FROM THE LIVE TABLE, NOT TYPED. These 72 ranges are every code
     point with allowed = true in public.engraving_charset, read on 18 October
     2026 at 19:20:45 UTC, collapsed into inclusive [lo,hi] pairs: 4,000
     characters, 1,919 of them above U+FFFF. The table is the app's own list and
     engraving_charset_pattern() is built from it, so this is the same list the
     metafield publishes.

     THIS COPY IS ONLY USED WHEN THE PAGE CARRIES NO LIST, which is every page
     until the metafield is written to the store.

     THE GAPS ARE DELIBERATE. The ranges stop and start again around the 240
     characters LightBurn draws blank; those are in the app's catalogue marked
     not allowed, and they stay refused. Everything Unicode has that the table
     does not name is refused too.

     DO NOT HAND-EDIT. Regenerate it from the table, check the count against
     public.engraving_charset_cache.allowed_count, and put that row's
     allowed_md5 into BUILT_IN_ALLOWED_MD5 below. */
  var BUILT_IN_RANGES = [
    [32,126], [183,183], [192,214], [216,246],
    [248,255], [305,305], [338,339], [352,353],
    [376,376], [8208,8231], [8240,8286], [8352,8383],
    [8448,8587], [8592,9210], [9312,9471], [9632,10175],
    [10224,10239], [10496,10623], [11008,11123], [11126,11157],
    [11160,11193], [11197,11208], [11210,11217], [11244,11247],
    [65039,65039], [126976,127019], [127024,127123], [127136,127150],
    [127153,127167], [127169,127183], [127185,127221], [127232,127244],
    [127248,127278], [127280,127337], [127344,127386], [127744,128334],
    [128336,128591], [128640,128722], [128725,128725], [128736,128748],
    [128752,128762], [128768,128883], [128896,128901], [128903,128903],
    [128905,128905], [128908,128909], [128913,128920], [128922,128926],
    [128928,128960], [128962,128964], [128966,128970], [128972,128974],
    [128976,128976], [128978,128978], [128980,128980], [128992,129003],
    [129024,129035], [129040,129095], [129104,129113], [129120,129159],
    [129168,129197], [129293,129349], [129351,129393], [129395,129398],
    [129402,129442], [129445,129450], [129454,129482], [129485,129535],
    [129648,129651], [129656,129658], [129664,129666], [129680,129685]
  ];

  /* =============================== SYMBOLS ===============================
     THE SYMBOLS ARE IN THE APP'S OWN LIST NOW, since migrations 1650 and 1651,
     and the hatched ones since 1652. Lorenzo, 18 October 2026: "these are all
     tested in the engraver so the engraver can do it. There is no need to do
     any testing if the engraver works with them. All I want from you is to set
     up in the app." So the star, the praying hands and the rest are in
     BUILT_IN_RANGES above and need nothing switching on.

     useSymbols() therefore DOES NOTHING. It is kept only so that a page written
     against the older file still runs - the ring page never called it, and the
     cart never called it either. It can go the day nobody can find a caller. */

  function emptyMap() { return {}; }

  /* ------------------------------------------------- a list is RANGES

     EVERY LIST IS A SORTED LIST OF RANGES, and a lookup is a binary search
     rather than a character-by-character map. The app's payload is free to name
     a range with a million characters in it; expanding that into an object
     would hang the page on a phone, and a list this file did not write is
     exactly the one to be careful with. */

  function isArray(x) { return Object.prototype.toString.call(x) === '[object Array]'; }
  function isInt(x) { return typeof x === 'number' && isFinite(x) && Math.floor(x) === x; }

  /* Sorted, and touching or overlapping pairs folded together, so the search
     below can stop at the first range that is past the character. */
  function mergeRanges(list) {
    var out = [], i, last;
    list = list.slice().sort(function (a, b) { return (a[0] - b[0]) || (a[1] - b[1]); });
    for (i = 0; i < list.length; i++) {
      last = out[out.length - 1];
      if (last && list[i][0] <= last[1] + 1) {
        if (list[i][1] > last[1]) last[1] = list[i][1];
      } else {
        out.push([list[i][0], list[i][1]]);
      }
    }
    return out;
  }

  function inRanges(ranges, cp) {
    var lo = 0, hi = ranges.length - 1, mid;
    while (lo <= hi) {
      mid = (lo + hi) >> 1;
      if (cp < ranges[mid][0]) { hi = mid - 1; }
      else if (cp > ranges[mid][1]) { lo = mid + 1; }
      else { return true; }
    }
    return false;
  }

  /* Sorted and folded once at load. The generator already emits them sorted
     and disjoint; this is belt and braces, and costs one pass over 72 pairs. */
  var BUILT_IN = mergeRanges(BUILT_IN_RANGES);

  /* ------------------------------------------------- the app's own list */

  /* WHICH VERSION OF THE APP'S LIST THE COPY ABOVE WAS BUILT AGAINST, and which
     version of the app's normalising this file mirrors. The app publishes the
     same two hashes beside its list, so a page can say out loud when the two
     have drifted apart. They are COMPARED AS STRINGS and never recomputed here:
     working them out again in the browser would only be a second chance to get
     them wrong. */
  var BUILT_IN_ALLOWED_MD5 = 'de3d1eda090f8fe1e583feacc4cbc7cf';
  var MIRRORED_NORMALISE_MD5 = '630c54c1b29e57395b06fd56f5c9353c';

  function say(how, what) {
    try {
      if (window.console && typeof console[how] === 'function') {
        console[how]('[SestoEngrave] ' + what);
      }
    } catch (e) {}
  }

  /* WHAT A GOOD PAYLOAD LOOKS LIKE. This list decides what a customer may pay
     for, and this file did not write it, so it is checked before it is believed
     and anything short of right is said out loud and then ignored in favour of
     the copy above. Refusing a broken list is the safe direction: the fallback
     is a real list, not an empty one, so a bad payload never leaves the box
     accepting everything or refusing everything. */
  function readPayload(raw) {
    var data, ranges, clean = [], count = 0, i, lo, hi;

    try { data = JSON.parse(raw); }
    catch (e) { return { bad: 'the list in the page is not JSON' }; }

    /* VERSION 1 OR 2. They are the same shape; 2 is what the app publishes now.
       A version this file has never heard of is refused rather than guessed at,
       because the next one may not mean [lo,hi] by "ranges". */
    if (!data || (data.v !== 1 && data.v !== 2)) {
      return { bad: 'the list is version ' + (data ? data.v : 'missing') +
                    ', and this page understands 1 and 2' };
    }

    ranges = data.ranges;
    if (!isArray(ranges) || !ranges.length) { return { bad: 'the list has no ranges' }; }

    for (i = 0; i < ranges.length; i++) {
      if (!isArray(ranges[i]) || ranges[i].length !== 2) {
        return { bad: 'range ' + i + ' is not a pair' };
      }
      lo = ranges[i][0]; hi = ranges[i][1];
      if (!isInt(lo) || !isInt(hi)) {
        return { bad: 'range ' + i + ' is not whole numbers' };
      }
      if (lo < 0 || hi > 0x10FFFF || lo > hi) {
        return { bad: 'range ' + i + ' is back to front or outside Unicode' };
      }
      clean.push([lo, hi]);
      count += hi - lo + 1;
    }

    if (data.chars_allowed !== count) {
      return { bad: 'the list says ' + data.chars_allowed +
                    ' characters and its ranges give ' + count };
    }

    return {
      ranges: mergeRanges(clean),
      allowed_md5: data.allowed_md5 || null,
      normalise_md5: data.normalise_md5 || null,
      updated_at: data.updated_at || null
    };
  }

  /* READ LAZILY, and read AGAIN only when the payload on the page is not the
     one we read last. The cart replaces its own HTML after every change, so the
     tag can arrive - or be replaced - long after this file loaded. Keying on
     the TEXT rather than the element means an identical list coming back in a
     fresh element is not re-read, which is also what makes the two messages
     below happen once rather than on every keystroke. */
  var state = null;

  function listTag() {
    try { return document.querySelector('[data-sp-engrave-list]'); }
    catch (e) { return null; }
  }

  function adopt(raw) {
    var s = {
      raw: raw,
      from: 'built-in',
      ranges: BUILT_IN,
      allowed_md5: BUILT_IN_ALLOWED_MD5,
      normalise_md5: MIRRORED_NORMALISE_MD5,
      updated_at: null
    };
    if (raw === null) { return s; }

    var got = readPayload(raw);
    if (got.bad) {
      say('warn', 'using the built-in list: ' + got.bad + '.');
      return s;
    }

    /* THE APP'S LIST REPLACES THE COPY ABOVE, whole. */
    s.from = 'metafield';
    s.ranges = got.ranges;
    s.allowed_md5 = got.allowed_md5;
    s.normalise_md5 = got.normalise_md5;
    s.updated_at = got.updated_at;

    /* NORMALISING IS THE HALF THIS FILE STILL MIRRORS BY HAND. The list can come
       from the app; the tidying up that happens before the list is applied
       cannot, so if the app's engraving_normalise has changed, this mirror may
       now judge a text the app would have tidied differently. The app's list is
       still used - it is the better of the two - but somebody is told. */
    if (s.normalise_md5 && s.normalise_md5 !== MIRRORED_NORMALISE_MD5) {
      say('warn', "the app's normalising has changed (" + s.normalise_md5 +
                  ', this file mirrors ' + MIRRORED_NORMALISE_MD5 +
                  "). Using the app's list anyway; this mirror may now disagree " +
                  'with the app about a text.');
    }
    if (s.allowed_md5 && s.allowed_md5 !== BUILT_IN_ALLOWED_MD5) {
      say('info', "the app's list has moved on from the copy in this file (" +
                  s.allowed_md5 + ' against ' + BUILT_IN_ALLOWED_MD5 +
                  "). The app's list is in use; the fallback copy is stale.");
    }
    return s;
  }

  function current() {
    var el = listTag();
    var raw = el ? (el.textContent || '') : null;
    if (!state || state.raw !== raw) { state = adopt(raw); }
    return state;
  }

  /* WHICH LIST THIS PAGE IS ACTUALLY USING, for anybody who needs to know
     without reading the page's HTML. */
  function source() {
    var s = current();
    return {
      from: s.from,
      allowed_md5: s.allowed_md5,
      normalise_md5: s.normalise_md5,
      updated_at: s.updated_at
    };
  }

  /* The list in force, with the symbols folded in if they have been switched
     on. THE SYMBOLS ONLY EVER ADD: whatever the app allows stays allowed. */
  function activeRanges() {
    return current().ranges;
  }

  /* DOES NOTHING, ON PURPOSE. It used to switch on a list of symbols the app
     did not have yet; the app has them now (1650, 1651, 1652), so there is
     nothing left to switch and nothing a caller could usefully ask for. It is
     kept so a page written against the older file still runs. Checked on
     18 October 2026: assets/ring-pdp.js calls message() and nothing else, and
     assets/sp-cart.js calls message() too, so this has no caller in the theme. */
  function useSymbols() {}

  /* ------------------------------------------- reading a text, character by
     character. NOT letter by letter: a heart or a moon above U+FFFF arrives as
     two surrogates, and counting those separately would report two refused
     characters that neither of them is. */

  function codePoints(s) {
    var out = [], i = 0, n = s.length, hi, lo;
    while (i < n) {
      hi = s.charCodeAt(i);
      if (hi >= 0xD800 && hi <= 0xDBFF && i + 1 < n) {
        lo = s.charCodeAt(i + 1);
        if (lo >= 0xDC00 && lo <= 0xDFFF) {
          out.push({ cp: (hi - 0xD800) * 0x400 + (lo - 0xDC00) + 0x10000,
                     ch: s.substr(i, 2) });
          i += 2;
          continue;
        }
      }
      /* A surrogate with no partner falls through to here and is refused, which
         is right: it is half a character and cannot be engraved. */
      out.push({ cp: hi, ch: s.charAt(i) });
      i += 1;
    }
    return out;
  }

  /* THE CHARACTERS WE CANNOT ENGRAVE, each one once, in the order the customer
     typed them. An empty array means the text is fine. */
  function refused(text) {
    var list = codePoints(normalise(text));
    var ranges = activeRanges();
    var seen = emptyMap(), out = [], i;
    for (i = 0; i < list.length; i++) {
      if (inRanges(ranges, list[i].cp)) { continue; }
      if (seen[list[i].cp]) { continue; }
      seen[list[i].cp] = true;
      out.push(list[i].ch);
    }
    return out;
  }

  /* ------------------------------------------------------------ the sentence */

  /* A CHARACTER WITH NOTHING TO SHOW. Pasting from a website brings these in by
     the handful - a zero-width space, a byte-order mark, the selector that
     turns an emoji back into a line drawing. Printing one would show the
     customer an empty gap and ask them to remove it, so it is named instead.
     The ranges are the control characters, the format characters, the
     separators, the variation selectors and the lone surrogates. */
  var INVISIBLE = [
    [0x0000, 0x001F], [0x007F, 0x009F],            /* control                */
    [0x00AD, 0x00AD],                              /* soft hyphen            */
    [0x0600, 0x0605], [0x061C, 0x061C],            /* Arabic format          */
    [0x06DD, 0x06DD], [0x070F, 0x070F],
    [0x115F, 0x1160], [0x17B4, 0x17B5],            /* fillers, invisible vowels */
    [0x180B, 0x180F],                              /* Mongolian selectors    */
    [0x2000, 0x200F],                              /* spaces, joiners, marks */
    [0x2028, 0x202F], [0x205F, 0x206F],            /* separators, formats    */
    [0x2800, 0x2800],                              /* blank braille          */
    [0x3000, 0x3000], [0x3164, 0x3164],
    [0xD800, 0xDFFF],                              /* half a character       */
    [0xFE00, 0xFE0F],                              /* variation selectors    */
    [0xFEFF, 0xFEFF], [0xFFA0, 0xFFA0],
    [0xFFF9, 0xFFFB],
    [0x1BCA0, 0x1BCA3], [0x1D173, 0x1D17A],
    [0xE0000, 0xE0FFF]                             /* tags and selectors     */
  ];

  function invisibleCp(cp) {
    for (var i = 0; i < INVISIBLE.length; i++) {
      if (cp >= INVISIBLE[i][0] && cp <= INVISIBLE[i][1]) { return true; }
    }
    return false;
  }

  /* ------------------------------------------ one emoji is one character

     WHAT THE CUSTOMER TYPED, NOT WHAT UNICODE STORED. Lorenzo, 18 October
     2026: "yes change the message to name the whole emoji."

     A genie is U+1F9DE, a zero-width joiner and U+2642 with a selector on it.
     Only the joiner is off the list, so naming the refused CHARACTER told the
     customer "we can't engrave an invisible character" under an emoji they
     could see perfectly well, and left them nothing to delete. A flag was
     worse: it came out as two letters nobody recognises. So the SENTENCE is
     built out of what a keyboard calls one character - a grapheme cluster -
     while refused() is untouched and still answers about code points. The
     VERDICT does not move: a cluster is refused when any code point in it is,
     so the sentence appears in exactly the cases it did before. */

  var segmenter;   /* undefined = not looked for yet, null = not available */

  function clusters(s) {
    if (segmenter === undefined) {
      segmenter = null;
      try {
        if (typeof Intl !== 'undefined' && Intl &&
            typeof Intl.Segmenter === 'function') {
          segmenter = new Intl.Segmenter('en', { granularity: 'grapheme' });
        }
      } catch (e) { segmenter = null; }
    }
    if (segmenter && typeof Array.from === 'function') {
      try {
        var parts = Array.from(segmenter.segment(s), function (x) { return x.segment; });
        if (parts.length) { return parts; }
      } catch (e) {}
    }
    return groupByHand(s);
  }

  /* The hand-rolled grouper, for a browser with no Intl.Segmenter. It is not
     the whole Unicode algorithm - it is the parts an engraving box meets. */
  /* WHAT HANGS OFF THE CHARACTER IN FRONT OF IT. The selectors, the keycap,
     the skin tones, the tags - and the combining marks, which are not only the
     Latin accents. A Hebrew or Arabic word is a letter with two or three marks
     sitting on it, and leaving those out named "בְּרִית" one mark at a time.
     Checked against Intl.Segmenter on every real engraving ever ordered, which
     is how the Hebrew and Arabic rows were found. */
  var EXTENDERS = [
    [0x0300, 0x036F],                               /* Latin accents          */
    [0x0483, 0x0489],                               /* Cyrillic               */
    [0x0591, 0x05BD], [0x05BF, 0x05BF],             /* Hebrew points          */
    [0x05C1, 0x05C2], [0x05C4, 0x05C5], [0x05C7, 0x05C7],
    [0x0610, 0x061A], [0x064B, 0x065F], [0x0670, 0x0670],   /* Arabic         */
    [0x06D6, 0x06DC], [0x06DF, 0x06E4], [0x06E7, 0x06E8], [0x06EA, 0x06ED],
    [0x0711, 0x0711], [0x0730, 0x074A],             /* Syriac                 */
    [0x07A6, 0x07B0],                               /* Thaana                 */
    [0x0900, 0x0903], [0x093A, 0x094F],             /* Devanagari             */
    [0x0951, 0x0957], [0x0962, 0x0963],
    [0x0E31, 0x0E31], [0x0E34, 0x0E3A], [0x0E47, 0x0E4E],   /* Thai           */
    [0x1AB0, 0x1AFF], [0x1DC0, 0x1DFF],             /* more combining blocks  */
    [0x20D0, 0x20F0],                               /* marks for symbols,
                                                       the keycap among them  */
    [0xFE00, 0xFE0F],                               /* variation selectors    */
    [0xFE20, 0xFE2F],                               /* combining half marks   */
    [0x1F3FB, 0x1F3FF],                             /* skin tones             */
    [0xE0020, 0xE007F]                              /* tags                   */
  ];

  function isExtender(cp) {
    for (var i = 0; i < EXTENDERS.length; i++) {
      if (cp >= EXTENDERS[i][0] && cp <= EXTENDERS[i][1]) { return true; }
    }
    return false;
  }
  function isFlagLetter(cp) { return cp >= 0x1F1E6 && cp <= 0x1F1FF; }

  function groupByHand(s) {
    var list = codePoints(s), out = [], i = 0, text, base;
    while (i < list.length) {
      text = list[i].ch;
      base = list[i].cp;
      i += 1;

      /* A flag is exactly two regional indicators, never three. */
      if (isFlagLetter(base) && i < list.length && isFlagLetter(list[i].cp)) {
        out.push(text + list[i].ch);
        i += 1;
        continue;
      }

      for (;;) {
        while (i < list.length && isExtender(list[i].cp)) {
          text += list[i].ch;
          i += 1;
        }
        /* A joiner takes the thing after it with it, and then the loop goes
           round again - that is how a family of four stays one character. */
        if (i + 1 < list.length && list[i].cp === 0x200D) {
          text += list[i].ch + list[i + 1].ch;
          i += 2;
          continue;
        }
        break;
      }
      out.push(text);
    }
    return out;
  }

  function clusterRefused(text, ranges) {
    var list = codePoints(text), i;
    for (i = 0; i < list.length; i++) {
      if (!inRanges(ranges, list[i].cp)) { return true; }
    }
    return false;
  }

  /* ONLY A CLUSTER WITH NOTHING IN IT TO SEE gets called invisible. A heart
     with a text selector on it is still a heart and is named as one; a joiner
     left on its own between two letters is not. */
  function clusterInvisible(text) {
    var list = codePoints(text), i;
    if (!list.length) { return false; }
    for (i = 0; i < list.length; i++) {
      if (!invisibleCp(list[i].cp)) { return false; }
    }
    return true;
  }

  var SHOW_AT_MOST = 5;

  /* WHAT TO PUT UNDER THE BOX. '' when there is nothing to say, so the caller
     can hide the line by asking for its length. */
  function message(text) {
    var ranges = activeRanges();
    var parts = clusters(normalise(text));
    var shown = [], seen = {}, more = false, i, name, key;

    for (i = 0; i < parts.length; i++) {
      if (!clusterRefused(parts[i], ranges)) { continue; }

      /* NAMED ONCE, however many there are. "an invisible character an
         invisible character" is not a sentence, and the customer clears them
         all with the same keystroke anyway. The same goes for the same emoji
         typed twice. */
      name = clusterInvisible(parts[i]) ? 'an invisible character' : parts[i];
      key = '#' + name;                /* so a cluster called "constructor"
                                          cannot collide with Object's own */
      if (seen[key]) { continue; }
      if (shown.length === SHOW_AT_MOST) { more = true; break; }
      seen[key] = true;
      shown.push(name);
    }

    if (!shown.length) { return ''; }

    /* "it" or "them" follows what is actually on screen, not how many
       characters are behind it - two invisible ones print as one phrase, and
       "please remove them" after one phrase reads wrong. */
    var many = shown.length > 1 || more;

    return 'We can\'t engrave ' + shown.join(' ') + (more ? ' …' : '') +
           ' - please remove ' + (many ? 'them' : 'it') + '.';
  }

  window.SestoEngrave = {
    normalise: normalise,
    refused: refused,
    message: message,
    useSymbols: useSymbols,
    source: source
  };
}());
